import React from "react";
import { useField } from "formik";
import { Label, FormField, Select } from "semantic-ui-react";

export default function MySelectInput({ label, ...props }) {
  const [field, meta, helpers] = useField(props);
  return (
    <FormField error={meta.touched && !!meta.error}>
      <label for={props.name} id={props.name}>
        {label}
      </label>
      <Select
        clearable
        value={field.value || null}
        onChange={(e, d) => helpers.setValue(d.value)}
        onBlur={() => helpers.setTouched(true)}
        {...props}
      />
      {meta.touched && meta.error ? (
        <Label style={{ marginTop: "3px", border: "0px" }} basic color="red">
          {meta.error}
        </Label>
      ) : null}
    </FormField>
  );
}
